import { GetterTree } from 'vuex'
import { RootState } from '@/store/types'
import { WorkFileTrackingState } from './types';

export const getters: GetterTree<WorkFileTrackingState, RootState> = {}
